var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMp3 = function SvgMp3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#1C7ABE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.673 13.5h1.043l1.102 2.688h.046L7.966 13.5h1.043v4h-.82v-2.604h-.034L7.12 17.48h-.558l-1.035-2.593h-.034V17.5h-.82zm5.198 4v-4h1.578q.455 0 .775.174.321.172.489.478.17.306.17.704t-.172.703q-.173.304-.498.474t-.786.17h-1.005v-.678h.869a.85.85 0 0 0 .402-.084.56.56 0 0 0 .238-.236.74.74 0 0 0 .08-.35.7.7 0 0 0-.08-.347.54.54 0 0 0-.238-.233.9.9 0 0 0-.406-.084h-.57V17.5zm5.18.055q-.436 0-.778-.15a1.33 1.33 0 0 1-.538-.419 1.05 1.05 0 0 1-.2-.617h.85a.44.44 0 0 0 .097.258q.09.11.238.17t.334.06a.8.8 0 0 0 .342-.068.56.56 0 0 0 .232-.19.48.48 0 0 0 .084-.279.47.47 0 0 0-.09-.283.6.6 0 0 0-.254-.195 1 1 0 0 0-.39-.07h-.373v-.622h.373a.8.8 0 0 0 .338-.066.55.55 0 0 0 .23-.184.48.48 0 0 0 .082-.277.48.48 0 0 0-.271-.443.776.776 0 0 0-.611-.002.55.55 0 0 0-.23.174.46.46 0 0 0-.091.265h-.81q.005-.345.197-.61.192-.262.515-.411.326-.15.737-.15.414 0 .724.15t.483.406q.174.255.171.57a.78.78 0 0 1-.209.56.95.95 0 0 1-.544.286v.031q.441.057.671.307a.87.87 0 0 1 .23.621.98.98 0 0 1-.196.607 1.3 1.3 0 0 1-.545.418 2 2 0 0 1-.797.153"
  })));
};
export default SvgMp3;